module.exports = __webpack_public_path__ + "img/bg_slide_7.ce044e3b.jpeg";